import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { TopicTypes } from '../data/topicEditor/constants';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ZeroState = ({
  onOpenCreateTopicDialog
}) => {
  return /*#__PURE__*/_jsxs("section", {
    "data-test-id": "topic-editor-zero-state",
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => onOpenCreateTopicDialog(TopicTypes.CLUSTER),
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.zeroState.actions.addCoreTopic"
      })
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "400",
      as: "p",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.zeroState.description"
      })
    })]
  });
};